/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {activityPageInternal} from '../api'

export const useMutationActivityPageInternal = createReactQueryMutationHook('activityPageInternal', activityPageInternal)
